import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

const cookieSections = [
  ["What cookies and local storage are", "Cookies are small files a website or service provider can place in a browser. Local storage is a similar browser feature that can retain data for a site. This store currently uses local storage for the cart and does not set its own non-essential analytics or advertising cookies."],
  ["Store storage inventory", "The key named cartItems stores product identifiers, selected variants, and quantities so the cart remains available while you browse and when you return using the same browser. It remains until the cart is cleared or you remove the site's browser data."],
  ["Strictly necessary operation", "Technical infrastructure may process short-lived request, security, load-balancing, or delivery data needed to serve pages and prevent abuse. These mechanisms are used for service operation rather than advertising."],
  ["Hosted payment page", "When you choose Pay now, you are sent to the payment provider's hosted page. That provider may set cookies or similar technologies for authentication, fraud prevention, security, payment preferences, and transaction processing under its own notice."],
  ["No advertising or optional analytics", "ioomparade does not currently set advertising cookies, use cross-site behavioural advertising pixels, or enable optional site analytics cookies. If that changes, this policy and any legally required consent control will be updated before the new technology is used."],
  ["Browser and device controls", "You can inspect, block, or delete cookies and local storage in your browser settings. Private-browsing modes and some privacy tools may remove storage automatically. Blocking or clearing essential storage can empty the cart or stop checkout features from working as expected."],
  ["Do Not Track and Global Privacy Control", "Because the store does not currently sell personal information, share it for cross-context behavioural advertising, or place advertising cookies, browser opt-out signals do not change those practices. If relevant practices change, we will explain how supported signals are handled."],
  ["Policy updates", "We may update this notice when store features, providers, or legal requirements change. The effective date identifies the current version."],
];

function Cookies() {
  return (
    <main className="ink-info-page ink-info-page--privacy">
      <div className="ink-info-page__inner">
        <header className="ink-info-page__header">
          <p className="ink-info-page__eyebrow">Your choices</p>
          <h1>Cookie Policy</h1>
          <p className="ink-info-page__lead">
            This notice explains the limited browser storage used by ioomparade and how you can manage it.
          </p>
          <p className="policy-updated">
            Effective and last updated: <time dateTime="2026-10-16">October 16, 2026</time>
          </p>
        </header>
        <div className="privacy-sections">
          {cookieSections.map(([title, text], index) => (
            <section className="privacy-section" key={title}>
              <span className="privacy-section__number" aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div><h2>{title}</h2><p>{text}</p></div>
            </section>
          ))}
        </div>
        <section className="privacy-contact">
          <div>
            <p className="ink-info-page__kicker">Related information</p>
            <h2>How we handle personal information</h2>
          </div>
          <Link className="ink-info-page__button" to="/privacy">Read the Privacy Policy</Link>
        </section>
      </div>
    </main>
  );
}

export default Cookies;
